import { z } from 'zod';
import { Dateish } from './common';

/** GET /tickets/:n/rating — pesquisa CSAT do ticket (1 por ticket). */
export const TicketRatingSchema = z.object({
  id: z.number().int(),
  ticketNumber: z.number().int(),
  /** 1–5; null = enviada e ainda não respondida */
  score: z.number().int().min(1).max(5).nullable(),
  comment: z.string().nullable(),
  sentAt: Dateish.nullable(),
  respondedAt: Dateish.nullable(),
  createdAt: Dateish,
});
export type TicketRating = z.infer<typeof TicketRatingSchema>;

/** GET /public/rate/:token — mínimo para renderizar a página de avaliação. */
export const PublicRatingViewSchema = z.object({
  ticketNumber: z.number().int(),
  title: z.string(),
  /** true = já avaliada (a página mostra agradecimento, não o formulário) */
  responded: z.boolean(),
});
export type PublicRatingView = z.infer<typeof PublicRatingViewSchema>;

/** POST /public/rate/:token — uma resposta só (repetida ⇒ 409 already_rated). */
export const RateBodySchema = z.object({
  score: z.number().int().min(1).max(5),
  comment: z.string().optional(),
});
export type RateBody = z.infer<typeof RateBodySchema>;
